import { AnalyticsHeader } from "./components/analytics-header";
import { AnalyticsToolbar } from "./components/analytics-toolbar";
import { AnalyticsFacetedFilters } from "./components/analytics-faceted-filters";
import { ReturnRateChart } from "./components/return-rate-chart";
import { CountryReturnRateMap } from "./components/country-return-rate-map";
import { ProductsAnalyticsTable } from "./components/products-table/products-analytics-table";

export default function AnalyticsPage() {
  return (
    <div className="flex items-center justify-center">
      <div className="grid grid-cols-4 gap-4 w-full max-w-[1600px] lg:px-16 lg:py-6 px-6 py-4">
        <AnalyticsHeader />
        <AnalyticsToolbar />
        <AnalyticsFacetedFilters />
        {/* Chart and Map side by side */}
        <ReturnRateChart />
        <CountryReturnRateMap />
        {/* Products table full width */}
        <ProductsAnalyticsTable />
      </div>
    </div>
  );
}
